import { Column } from 'primereact/column';
import { DataTable, SortOrder } from 'primereact/datatable';
import React, { useEffect, useRef, useState } from 'react';
import westImg from 'src/assets/img/westImg.png';
import fsImg from 'src/assets/img/fsImg.png';
import logImg from 'src/assets/img/logImg.png';
import lianiImg from 'src/assets/img/lianiImg.png';
import { TiFlash } from 'react-icons/ti';
import { FaCircleExclamation } from 'react-icons/fa6';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import cupIcon from 'src/assets/svgs/cup.svg';
import { Tooltip } from 'flowbite-react';
import { BsInfoCircle } from 'react-icons/bs';
import { getRemovetzTime } from 'src/utils/function';

const EmployeeList = ({ modalOpenEmployee, employeeData, getEmployee, isLoading, selectedRange }: any) => {
    const [first, setFirst] = useState(0);
    const [page, setPage] = useState(0);

    const [sortField, setSortField] = useState<string>('totalHours');
    const [sortOrder, setSortOrder] = useState<SortOrder>(-1);
    const isFirstRender = useRef(true);

    const onSort = (e: any) => {
        setSortField(e.sortField);
        setSortOrder(e.sortOrder);
        setPage(0);
        setFirst(0);
    };
    const Getcomp = (row: any) => (
        <div className="flex items-center gap-1">
            <img className="w-6 h-6 rounded-full" src={row.companyName === 'West' ? westImg : row.companyName === 'Log' ? logImg : row.companyName === 'Liani' ? lianiImg : fsImg} alt="img" />
            <div className="text-black text-xs font-medium font-['Satoshi Variable'] uppercase">{row.companyName}</div>
        </div>
    );
    const Getjobtype = (row: any) => (
        <div className="flex items-center">
            <div className="flex items-center gap-0 relative">
                {row.isAsap ? (
                    <span className="w-5 h-5 rounded-full bg-red-50 text-red500 flex justify-center items-center mr-1 absolute left-[-25px]">
                        <TiFlash />
                    </span>
                ) : (
                    ''
                )}
                {row.isMandatory ? (
                    <span className={`iconresponsive w-5 h-5 rounded-full bg-white text-blue-800 flex justify-center items-center mr-1 absolute ${row.isAsap ? 'left-[-50px]' : 'left-[-25px]'}`}>
                        <FaCircleExclamation size={30} />
                    </span>
                ) : (
                    ''
                )}
            </div>
            <div className="text-black text-xs font-medium font-['Satoshi Variable'] uppercase">{row.jobType}</div>
        </div>
    );
    const GetJoinDate = (row: any) => getRemovetzTime(row.createdAt, 'MMM. DD, YY');
    const GetName = (row: any) => (
        <div className="gap-1">
            <div className="flex items-center gap-2 mb-1">
                {/* {row?.reward && row?.reward > 0 && <img src={cupIcon} alt={'cupIcon'} />} */}
                <p className="text-zinc-800 text-sm font-medium font-['Satoshi Variable'] leading-none">{`${row.name} ${row.surname}`}</p>
            </div>
            <p className="text-[#808080] text-xs font-medium font-['Satoshi Variable']">{row.email}</p>
        </div>
    );
    const GetRecruitedBy = (row: any) => (
        <div className="gap-1">
            {row.recruitedBy && row.recruitedBy !== '.' && row.recruitedBy !== '-' ? (
                <div className="flex">
                    <p className="text-black text-sm font-medium font-['Satoshi Variable'] truncate me-[6px]">{row.recruitedBy}</p>
                    <div className="flex items-center justify-center">
                        <Tooltip className="bg-black text-white max-w-[200px]" content={<>{`${row.recruitedBy} recruited total ${row.recruiterEmployeeCount} employees`}</>}>
                            <div className="w-4 h-4 ">
                                <BsInfoCircle className="text-[#9a9fa3] w-4 h-4" />
                            </div>
                        </Tooltip>
                    </div>
                </div>
            ) : (
                '-'
            )}
        </div>
    );

    const getEmployeeData = () => {
        let start = selectedRange?.start ? `&startDate=${selectedRange?.start}` : '';
        let end = selectedRange?.end ? `&endDate=${selectedRange?.end}` : '';
        let before = selectedRange?.before ? `&before=${selectedRange?.before}` : '';
        let type = selectedRange?.type ? `&type=${selectedRange?.type}` : '';
        const url = `?page=${page}&limit=10${start}${end}${before}${type}`;
        getEmployee(url, modalOpenEmployee);
    };
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        getEmployeeData();
    }, [page, sortOrder]);

    const onPageChange = (event: any) => {
        setFirst(event.first);
        setPage(event.page);
    };

    return (
        <div className="pt-4 min-w-[800px] max-lg:max-w-96">
            <div className="text-center text-zinc-800 text-lg font-medium font-['Satoshi Variable']">{modalOpenEmployee}</div>

            <div className={` h-[calc(100vh-150px)] scrollbar-hide overflow-y-auto`}>
                {isLoading ? (
                    <div className="card w-full h-[750px] flex justify-content-center items-center ">
                        <ProgressSpinner />
                    </div>
                ) : (
                    <>
                        <DataTable
                            value={employeeData.emp}
                            tableClassName="logdatatable jobdatatable"
                            emptyMessage="No Employee Record Found"
                            className=""
                            lazy
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                        >
                            <Column field="comp" header="Comp." body={Getcomp}></Column>
                            <Column field="jobtype" header="Job type" body={Getjobtype}></Column>
                            <Column field="name" header="Name" body={GetName}></Column>
                            <Column field="recruitedBy" header="Recruited By" body={GetRecruitedBy} style={{ minWidth: '200px' }}></Column>
                            <Column field="createdAt" header="Joined Ob" body={GetJoinDate}></Column>
                        </DataTable>
                    </>
                )}
                <Paginator
                    first={first}
                    rows={10}
                    totalRecords={employeeData.total}
                    onPageChange={onPageChange}
                    className="datatable_pagination datatable_pagination_joblist"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                />
            </div>
        </div>
    );
};

export default EmployeeList;
